import { Action } from '@ngrx/store';
import { IMenu } from 'src/app/models/menu.interface';

export enum EMenuActions {
  GetMenu = '[Menu] Get Menu',
  GetMenuSuccess = '[Menu] Get Menu Success'
}

export class GetMenu implements Action {
  public readonly type = EMenuActions.GetMenu;
  constructor(public payload: string) {
  }
}

export class GetMenuSuccess implements Action {
  public readonly type = EMenuActions.GetMenuSuccess;
  constructor(public payload: IMenu) {}
}

export type MenuActions =
  | GetMenu
  | GetMenuSuccess;

